import { empty, fill, reRender } from './render';
import * as s from '../../../../../home24-shared/components/quickview/constants/selectors';
import NotSellable from '../../../../../home24-shared/components/quickview/components/NotSellable/notsellable';

function notSellable(selectedChildSku) {
  empty(s.NOTSELLABLE, null, null);
  fill(s.NOTSELLABLE, null, null, NotSellable());
  setTimeout(() => {
    reRender(selectedChildSku);
  }, 2000);
}

export default notSellable;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/functions/render/notSellable.js
 **/